export default {
    navbar: {
        dashboard: '首页',
        logOut: '退出登录',
        changePassword: '修改密码',
        // profile: '个人中心',
        // theme: '换肤',
        // size: '布局大小'
    },

    route: {
        home: '首页',
        changePassword: '修改密码',

        pms: '商品管理',
        product: '商品列表',
        addProduct: '添加商品',
        updateProduct: '修改商品',
        productRecycle: '商品回收站',
        productComment: '商品评价',
        productCate: '商品分类',
        addProductCate: '添加商品分类',
        updateProductCate: '修改商品分类',
        productAttr: '商品类型',
        productAttrList: '商品属性列表',
        productSpecList: '商品规格属性列表',
        productParamList: '商品参数属性列表',
        addProductAttr: '添加商品属性',
        updateProductAttr: '修改商品属性',
        brand: '品牌管理',
        addBrand: '添加品牌',
        updateBrand: '编辑品牌',


        crm: '会员管理',
        member: '会员列表',
        memberDetail: '查看会员',
        updateMember: '编辑会员',
        memberLevel: '会员等级',
        integral: '积分规则',

        oms: '订单管理',
        order: '订单列表',
        orderDetail: '订单详情',
        deliverOrderList: '发货列表',
        orderSetting: '订单设置',
        returnApply: '退货申请处理',
        returnReason: '退货原因设置',
        returnApplyDetail: '退货原因详情',

        sms: '营销管理',
        advertise: '广告列表',
        addAdvertise: '添加广告',
        updateAdvertise: '编辑广告',

        mms: '商家管理',
        shop: '商家列表',
        addShop: '新增商家',
        updateShop: '修改商家',
        withdraw: '提现申请',

        cms: '资讯文章',
        article: '文章列表',
        addArticle: '新增文章',

        sys: '系统配置',
        params: '系统参数',
        exchangeRate: '汇率设置',
        permission: '权限管理',
        employeesList: '员工列表',
        roleList: '角色列表',
        allocMenu: '分配菜单',
        allocResource: '分配资源',
        menuList: '菜单列表',
        addMenu: '添加菜单',
        updateMenu: '修改菜单',
        resourceList: '资源列表',
        resourceCategory: '资源分类',
        appUpdateList: '软件升级',

        vms: '视频',
        video: '视频列表',
        videoTag: '视频标签列表',
        addVideoTag: '添加视频标签',
        updateVideoTag: '编辑视频标签',
        videoLivePlan: '直播计划列表',
        addVideoLivePlan: '添加直播计划',
        updateVideoLivePlan: '编辑直播计划',
        videoLiveMemberAuth: '会员认证',
        liveSetting: '直播设置',

        tagsView: {
            refresh: '刷新',
            close: '关闭',
            closeOthers: '关闭其它',
            closeAll: '关闭所有'
        }


        //   directivePermission: '指令权限',
        //   icons: '图标',
        //   components: '组件',
        //   tinymce: '富文本编辑器',
        //   markdown: 'Markdown',
        //   jsonEditor: 'JSON 编辑器',
        //   dndList: '列表拖拽',
        //   splitPane: 'Splitpane',
        //   avatarUpload: '头像上传',
        //   dropzone: 'Dropzone',
        //   sticky: 'Sticky',
        //   countTo: 'Count To',
        //   componentMixin: '小组件',
        //   backToTop: '返回顶部',
        //   dragDialog: '拖拽 Dialog',
        //   dragSelect: '拖拽 Select',
        //   dragKanban: '可拖拽看板',
        //   charts: '图表',
        //   keyboardChart: '键盘图表',
        //   lineChart: '折线图',
        //   mixChart: '混合图表',
        //   example: '综合实例',
        //   nested: '路由嵌套',
        //   menu1: '菜单1',
        //   'menu1-1': '菜单 1-1',
        //   'menu1-2': '菜单 1-2',
        //   'menu1-2-1': '菜单 1-2-1',
        //   'menu1-2-2': '菜单 1-2-2',
        //   'menu1-3': '菜单 1-3',
        //   menu2: '菜单 2',
        //   Table: 'Table',
        //   dynamicTable: '动态 Table',
        //   dragTable: '拖拽 Table',
        //   inlineEditTable: 'Table 内编辑',
        //   complexTable: '综合 Table',
        //   tab: 'Tab',
        //   form: '表单',
        //   createArticle: '创建文章',
        //   editArticle: '编辑文章',
        //   articleList: '文章列表',
        //   errorPages: '错误页面',
        //   page401: '401',
        //   page404: '404',
        //   errorLog: '错误日志',
        //   excel: 'Excel',
        //   exportExcel: '导出 Excel',
        //   selectExcel: '导出 已选择项',
        //   mergeHeader: '导出 多级表头',
        //   uploadExcel: '上传 Excel',
        //   zip: 'Zip',
        //   pdf: 'PDF',
        //   exportZip: 'Export Zip',
        //   theme: '换肤',
        //   clipboardDemo: 'Clipboard',
        //   i18n: '国际化',
        //   externalLink: '外链',
        //   profile: '个人中心'
        // },

        // login: {
        //   title: '系统登录',
        //   logIn: '登录',
        //   username: '账号',
        //   password: '密码',
        //   any: '随便填',
        //   thirdparty: '第三方登录',
        //   thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
        // },
        // documentation: {
        //   documentation: '文档',
        //   github: 'Github 地址'
        // },
        // permission: {
        //   addRole: '新增角色',
        //   editPermission: '编辑权限',
        //   roles: '你的权限',
        //   switchRoles: '切换权限',
        //   tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
        //   delete: '删除',
        //   confirm: '确定',
        //   cancel: '取消'
        // },
        // guide: {
        //   description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
        //   button: '打开引导'
        // },
        // components: {
        //   documentation: '文档',
        //   tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
        //   dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
        //   stickyTips: '当页面滚动到预设的位置会吸附在顶部',
        //   backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
        //   backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        //   imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
        // },
        // table: {
        //   dynamicTips1: '固定表头, 按照表头顺序排序',
        //   dynamicTips2: '不固定表头, 按照点击顺序排序',
        //   dragTips1: '默认顺序',
        //   dragTips2: '拖拽后顺序',
        //   title: '标题',
        //   importance: '重要性',
        //   type: '类型',
        //   remark: '点评',
        //   search: '搜索',
        //   add: '添加',
        //   export: '导出',
        //   reviewer: '审核人',
        //   id: '序号',
        //   date: '时间',
        //   author: '作者',
        //   readings: '阅读数',
        //   status: '状态',
        //   actions: '操作',
        //   edit: '编辑',
        //   publish: '发布',
        //   draft: '草稿',
        //   delete: '删除',
        //   cancel: '取 消',
        //   confirm: '确 定'
        // },
        // example: {
        //   warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
        // },
        // errorLog: {
        //   tips: '请点击右上角bug小图标',
        //   description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
        //   documentation: '文档介绍'
        // },
        // excel: {
        //   export: '导出',
        //   selectedExport: '导出已选择项',
        //   placeholder: '请输入文件名(默认excel-list)'
        // },
        // zip: {
        //   export: '导出',
        //   placeholder: '请输入文件名(默认file)'
        // },
        // pdf: {
        //   tips: '这里使用   window.print() 来实现下载pdf的功能'
        // },
        // theme: {
        //   change: '换肤',
        //   documentation: '换肤文档',
        //   tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
        // },
        // tagsView: {
        //   refresh: '刷新',
        //   close: '关闭',
        //   closeOthers: '关闭其它',
        //   closeAll: '关闭所有'
        // },
        // settings: {
        //   title: '系统布局配置',
        //   theme: '主题色',
        //   tagsView: '开启 Tags-View',
        //   fixedHeader: '固定 Header',
        //   sidebarLogo: '侧边栏 Logo'
        // }
    }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js